import {
  Input,
  inject,
  Component,
  DestroyRef,
  ElementRef,
  HostListener,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Subject, takeUntil, tap, timer } from 'rxjs';

@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    standalone: false
})
export class DropdownComponent {
  @Input() closeMethod!: () => void;
  @Input() title: string = '';

  private hoverCancel$ = new Subject<void>();

  private destroyRef = inject(DestroyRef);

  constructor(private eRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  clickOutside(event: MouseEvent): void {
    if (
      !this.eRef.nativeElement.parentElement?.parentElement?.contains(
        event.target,
      )
    ) {
      this.close();
    }
  }

  onMouseEnter(): void {
    // Cancel any pending close timer
    this.hoverCancel$.next();
  }

  onMouseLeave(): void {
    timer(300)
      .pipe(
        takeUntil(this.hoverCancel$), // Cancel timer if mouse re-enters
        takeUntilDestroyed(this.destroyRef),
        tap(() => {
          // this.close();
        }),
      )
      .subscribe();
  }

  close(): void {
    this.closeMethod?.();
  }

  cancel(): void {
    // Placeholder
  }
}
